import Wallet from "../../components/admin/Wallet";

export default function WalletPage() {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-6">Manage Wallet</h1>
      <Wallet />
    </div>
  );
}
